import { useIsUserSignedIn } from "../../core_stores/useAuthStore";
import { useProjectName } from "../../view_stores/useProjectConfigStore";
import {
  SideMenuBehavior,
  useSideMenuBehavior,
} from "../../view_stores/useSideMenuStore";
import { SplitPanel } from "../common_components/SplitPanel";
import SideMenuPanel from "../sideMenu/SideMenuPanel";
import { ProjectChat } from "./components/ProjectChat";
import { ProjectDashboard } from "./components/ProjectDashboard";

export function ProjectPageDefault() {
  const isUserSignedIn = useIsUserSignedIn();
  const sideMenuBehavior = useSideMenuBehavior();

  return (
    <div className="h-[100dvh] min-h-[650px] w-full bg-[#F2F3FD] dark:bg-[#1E2023] flex">
      {isUserSignedIn && <SideMenuPanel />}
      <div
        className={`${
          isUserSignedIn &&
          (sideMenuBehavior === SideMenuBehavior.PINNED
            ? "pl-[320px]"
            : "pl-[60px]")
        } flex-1 overflow-hidden transition-[padding] duration-300`}
      >
        <SplitPanel
          leftChild={<LeftColumn />}
          rightChild={<ProjectDashboard />}
          minLeftChildWidth={300}
          minRightChildWidth={300}
        />
      </div>
    </div>
  );
}

function LeftColumn() {
  const projectName = useProjectName();

  return (
    <div className="h-full w-full flex flex-col">
      <div
        className={`text-xl flex items-center
        px-[23px] h-[48px] w-full 
        overflow-x-auto whitespace-nowrap
        border-b-2 border-white/50 dark:border-[#373B40]`}
      >
        {projectName}
      </div>
      <div className="flex-1 overflow-hidden">
        <ProjectChat />
      </div>
    </div>
  );
}
